var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.787,
    height: 18.564,
    viewBox: "0 0 18.787 18.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "male-icon",
    transform: "translate(0 -0.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65264",
    "data-name": "Path 65264",
    d: "M0,18.573v-3c1.605-.714,6.521-2.073,6.752-4.038C6.8,11.09,5.758,9.4,5.518,8.588a2.962,2.962,0,0,1-.136-2.982,6.239,6.239,0,0,0,.128-2.069c0-4.7,8.245-4.706,8.245,0,0,.595-.138,1.688.187,2.156a3,3,0,0,1-.194,2.894c-.292.852-1.4,2.463-1.309,2.945.353,1.8,4.913,3,6.349,3.639v3.4L0,18.573Z",
    transform: "translate(0 0)",
    fill: "#707070",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.6ab35ac42a443195784441aa5bc8fc7b.svg";
export { ForwardRef as ReactComponent };